<template>
  <div class="box-admin new-client-wrapper">
    <b-form @submit.prevent="onSubmit">
      <div class="col-md-12">
        <h1>{{ titre }}</h1>
      </div>
      <div class="row col-md-12">
        <div class="col-md-4">
          <b-form-group
            id="num-client-group"
            label="Numero de client"
            label-for="num-client-input"
            v-if="isEditMode"
          >
            <div id="num-client-input" class="form-control">
              {{ form.numero }}
            </div>
          </b-form-group>

          <fieldset>
            <legend>Informations générales</legend>

            <b-form-group
              id="nom-societe-group"
              label="Nom de la société *"
              label-for="nom-societe-input"
            >
              <b-form-input
                v-model="form.nom"
                id="nom-societe-input"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="adresse-group"
              label="Adresse *"
              label-for="adresse-input"
            >
              <b-form-input
                v-model="form.adresse"
                id="adresse-input"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="complement-adresse-group"
              label="Complément d'adresse"
              label-for="complement-adresse-input"
            >
              <b-form-input
                v-model="form.complementAdresse"
                id="complement-adresse-input"
                type="text"
              >
              </b-form-input>
            </b-form-group>

            <div class="row">
              <b-form-group
                id="code-postal-group"
                label="Code postal *"
                label-for="code-postal-input"
                class="col-md-3"
              >
                <b-form-input
                  v-model="form.codePostal"
                  id="code-postal-input"
                  type="number"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-form-group
                id="ville-group"
                label="Ville *"
                label-for="ville-input"
                class="col-md-9"
              >
                <b-form-input
                  v-model="form.ville"
                  id="ville-input"
                  type="text"
                  required
                >
                </b-form-input>
              </b-form-group>
            </div>
            <b-form-group id="pays-group" label="Pays *" label-for="pays-input">
              <b-form-input
                v-model="form.pays"
                id="pays-input"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>

            <div>
              <b-form-checkbox
                id="facturation-check"
                name="facturation-check"
                v-model="selected"
                @change="autocompleteFacturationAdresse"
              >
                Utiliser la même adresse de facturation
              </b-form-checkbox>
            </div>
          </fieldset>

          <fieldset v-if="!selected">
            <legend>Adresse de facturation</legend>

            <b-form-group
              id="fac-nom-societe-group"
              label="Nom de la société *"
              label-for="fac-nom-societe-input"
            >
              <b-form-input
                v-model="form.facturationNom"
                id="fac-nom-societe-input"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="fac-adresse-group"
              label="Adresse *"
              label-for="fac-adresse-input"
            >
              <b-form-input
                v-model="form.facturationAdresse"
                id="fac-adresse-input"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>

            <b-form-group
              id="fac-complement-adresse-group"
              label="Complément d'adresse"
              label-for="fac-complement-adresse-input"
            >
              <b-form-input
                v-model="form.facturationComplementAdresse"
                id="fac-complement-adresse-input"
                type="text"
              >
              </b-form-input>
            </b-form-group>

            <div class="row">
              <b-form-group
                id="fac-code-postal-group"
                label="Code postal *"
                label-for="fac-code-postal-input"
                class="col-md-3"
              >
                <b-form-input
                  v-model="form.facturationCodePostal"
                  id="fac-code-postal-input"
                  type="number"
                  required
                >
                </b-form-input>
              </b-form-group>

              <b-form-group
                id="fac-ville-group"
                label="Ville *"
                label-for="fac-ville-input"
                class="col-md-9"
              >
                <b-form-input
                  v-model="form.facturationVille"
                  id="fac-ville-input"
                  type="text"
                  required
                >
                </b-form-input>
              </b-form-group>
            </div>

            <b-form-group
              id="fac-pays-group"
              label="Pays *"
              label-for="fac-pays-input"
            >
              <b-form-input
                v-model="form.facturationPays"
                id="fac-pays-input"
                type="text"
                required
              >
              </b-form-input>
            </b-form-group>
          </fieldset>

          <div class="button-wrap d-flex justify-content-end">
            <p class="obligatoire">* Champs obligatoire</p>
            <b-button variant="outline-primary">Annuler</b-button>
            <b-button variant="primary" class="lg-btn" type="submit"
              >Suivant</b-button
            >
          </div>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="nbadmin-group"
            label="Nombre d'administrateur"
            label-for="nbadmin-input"
          >
            <b-form-input
              v-model="form.nbAdmin"
              id="nbadmin-input"
              type="number"
              required
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            id="nbUtilisateur-group"
            label="Nombre d'utilisateur"
            label-for="nbUtilisateur-input"
          >
            <b-form-input
              v-model="form.nbUtilisateur"
              id="nbUtilisateur-input"
              type="number"
              required
            >
            </b-form-input>
          </b-form-group>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      titre: this.$route.params.id ? 'Modification client' : 'Nouveau client',
      readonly: false,
      selected: false,
      form: {
        nom: '',
        adresse: '',
        complementAdresse: '',
        codePostal: '',
        ville: '',
        pays: '',
        facturationNom: '',
        facturationAdresse: '',
        facturationComplementAdresse: '',
        facturationCodePostal: '',
        facturationVille: '',
        facturationPays: '',
        nbAdmin: 1,
        nbUtilisateur: 1
      },
      isEditMode: !!this.$route.params.id
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.readonly = true
      this.getClient(parseInt(this.$route.params.id)).then((resp) => {
        this.form = resp.data.data
      })
    }
  },
  methods: {
    ...mapActions(['addClient', 'getClient', 'updateClient', 'getClients']),
    autocompleteFacturationAdresse () {
      const facturationData = {
        facturationNom: this.form.nom,
        facturationAdresse: this.form.adresse,
        facturationComplementAdresse: this.form.complementAdresse,
        facturationCodePostal: this.form.codePostal,
        facturationVille: this.form.ville,
        facturationPays: this.form.pays
      }
      return facturationData
    },
    onSubmit () {
      let formData = {
        nom: this.form.nom,
        adresse: this.form.adresse,
        complementAdresse: this.form.complementAdresse,
        codePostal: this.form.codePostal,
        ville: this.form.ville,
        pays: this.form.pays,
        nbAdmin: this.form.nbAdmin,
        nbUtilisateur: this.form.nbUtilisateur
      }

      let facturationData = {}

      if (this.selected) {
        facturationData = this.autocompleteFacturationAdresse()
      } else {
        facturationData = {
          facturationNom: this.form.facturationNom,
          facturationAdresse: this.form.facturationAdresse,
          facturationComplementAdresse: this.form.facturationComplementAdresse,
          facturationCodePostal: this.form.facturationCodePostal,
          facturationVille: this.form.facturationVille,
          facturationPays: this.form.facturationPays
        }
      }

      formData = { ...facturationData, ...formData }

      // update société
      if (this.$route.params.id) {
        this.updateCLientInfo(formData)
        return
      }
      // ajout société
      this.addClientInfo(formData)
    },
    addClientInfo (formData) {
      this.addClient(formData).then((res) => {
        this.$toaster.success('Enregistré')
        this.$router.push({ name: 'List user', params: { id: res.data.data.id } })
      }, (err) => {
        this.$toaster.error(err)
      })
    },
    updateCLientInfo (formData) {
      let id = this.$route.params.id
      this.updateClient({ formData, id }).then((res) => {
        this.$toaster.success('Enregistré')
        this.$router.push({ name: 'List user', params: { id: res.data.data.id.toString() } })
      }, (err) => {
        this.$toaster.error(err)
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/ajoutClientEditeur/index.vue